export default "__VITE_ASSET__Bzffkf$W__"